import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex pt-8"
}
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "flex flex-col border-b-2 border-[#EAECF0] pb-5" }
const _hoisted_4 = { class: "font-semibold text-3xl text-[#101828]" }
const _hoisted_5 = { class: "text-[#475467] font-normal text-base" }
const _hoisted_6 = { class: "flex mt-8 p-8 bg-[#155EEF] rounded-lg justify-between" }
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "font-semibold text-lg" }
const _hoisted_9 = { class: "font-light text-sm mt-1" }
const _hoisted_10 = {
  key: 1,
  role: "list",
  class: "space-y-4 md:flex md:space-x-8 md:space-y-0 mt-14"
}
const _hoisted_11 = {
  key: 0,
  class: "group flex flex-col border-l-4 border-[#155EEF] py-2 pl-4 hover:border-[#0033CC] md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4"
}
const _hoisted_12 = { class: "text-sm font-medium text-[#155EEF] group-hover:text-[#0033CC]" }
const _hoisted_13 = { class: "text-sm font-medium" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col border-l-4 border-[#155EEF] py-2 pl-4 md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4",
  "aria-current": "step"
}
const _hoisted_15 = { class: "text-sm font-medium text-[#155EEF]" }
const _hoisted_16 = { class: "text-sm font-medium" }
const _hoisted_17 = {
  key: 2,
  class: "group flex flex-col border-l-4 border-gray-200 py-2 pl-4 hover:border-gray-300 md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4"
}
const _hoisted_18 = { class: "text-sm font-medium text-gray-500 group-hover:text-gray-700" }
const _hoisted_19 = { class: "text-sm font-medium" }
const _hoisted_20 = {
  key: 2,
  class: "text-base mt-14 w-full 2xl:w-[50%] mx-auto"
}
const _hoisted_21 = { class: "font-semibold text-3xl text-[#101828]" }
const _hoisted_22 = { class: "text-[#475467] font-normal text-base" }
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col items-center mt-8"
}
const _hoisted_24 = { class: "font-semibold text-sm" }
const _hoisted_25 = { class: "flex flex-col bg-white rounded-3xl border border-[#EAECF0] p-6" }
const _hoisted_26 = { class: "flex flex-col gap-3" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "mx-2 w-1/3" }
const _hoisted_29 = {
  for: "first_name",
  class: "block mb-2 text-sm font-medium text-[#344054]"
}
const _hoisted_30 = { class: "border border-[#D0D5DD] rounded-md flex p-[2px]" }
const _hoisted_31 = { class: "ml-[2px] border-none focus:outline-none focus:ring-0 focus:border-transparent" }
const _hoisted_32 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_33 = { class: "mx-2 w-1/3" }
const _hoisted_34 = {
  for: "last_name",
  class: "block mb-2 text-sm font-medium text-[#344054]"
}
const _hoisted_35 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_36 = { class: "mx-2 w-1/3" }
const _hoisted_37 = {
  for: "title",
  class: "block mb-2 text-sm font-medium text-[#344054]"
}
const _hoisted_38 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "mx-2 w-[32%]" }
const _hoisted_41 = {
  for: "email",
  class: "block mb-2 text-sm font-medium text-[#344054]"
}
const _hoisted_42 = { class: "border border-[#D0D5DD] rounded-md flex p-[2px] items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("svg", {
  class: "ml-[6px]",
  width: "24",
  height: "20",
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.66675 3.83325L8.47085 8.59612C9.02182 8.9818 9.29731 9.17465 9.59697 9.24934C9.86166 9.31532 10.1385 9.31532 10.4032 9.24934C10.7029 9.17465 10.9783 8.9818 11.5293 8.59612L18.3334 3.83325M5.66675 14.6666H14.3334C15.7335 14.6666 16.4336 14.6666 16.9684 14.3941C17.4388 14.1544 17.8212 13.772 18.0609 13.3016C18.3334 12.7668 18.3334 12.0667 18.3334 10.6666V5.33325C18.3334 3.93312 18.3334 3.23306 18.0609 2.69828C17.8212 2.22787 17.4388 1.84542 16.9684 1.60574C16.4336 1.33325 15.7335 1.33325 14.3334 1.33325H5.66675C4.26662 1.33325 3.56655 1.33325 3.03177 1.60574C2.56137 1.84542 2.17892 2.22787 1.93923 2.69828C1.66675 3.23306 1.66675 3.93312 1.66675 5.33325V10.6666C1.66675 12.0667 1.66675 12.7668 1.93923 13.3016C2.17892 13.772 2.56137 14.1544 3.03177 14.3941C3.56655 14.6666 4.26662 14.6666 5.66675 14.6666Z",
    stroke: "#667085",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = {
  key: 0,
  class: "text-sm font-medium text-[#344054] mt-2"
}
const _hoisted_46 = { class: "mx-2 w-[32%]" }
const _hoisted_47 = {
  for: "phone",
  class: "block mb-2 text-sm font-medium text-[#344054]"
}
const _hoisted_48 = { class: "border border-[#D0D5DD] rounded-md flex p-[2px]" }
const _hoisted_49 = { class: "ml-[2px] border-none focus:outline-none focus:ring-0 focus:border-transparent" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "31",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { id: "ic:baseline-delete-outline" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M9.28247 6.60547H11.7166C11.7166 6.28269 11.5883 5.97313 11.3601 5.74489C11.1319 5.51665 10.8223 5.38843 10.4995 5.38843C10.1767 5.38843 9.86717 5.51665 9.63893 5.74489C9.41069 5.97313 9.28247 6.28269 9.28247 6.60547ZM8.55225 6.60547C8.55225 6.08902 8.7574 5.59373 9.12259 5.22854C9.48777 4.86336 9.98306 4.6582 10.4995 4.6582C11.016 4.6582 11.5113 4.86336 11.8764 5.22854C12.2416 5.59373 12.4468 6.08902 12.4468 6.60547H15.4894C15.5862 6.60547 15.6791 6.64394 15.7476 6.71241C15.816 6.78088 15.8545 6.87375 15.8545 6.97058C15.8545 7.06741 15.816 7.16028 15.7476 7.22875C15.6791 7.29723 15.5862 7.33569 15.4894 7.33569H14.8517L14.2592 14.4447C14.2161 14.9618 13.9802 15.4439 13.5983 15.7953C13.2165 16.1467 12.7165 16.3418 12.1975 16.3418H8.8015C8.28255 16.3418 7.78256 16.1467 7.40068 15.7953C7.01881 15.4439 6.78293 14.9618 6.73983 14.4447L6.14737 7.33569H5.50964C5.41281 7.33569 5.31994 7.29723 5.25147 7.22875C5.183 7.16028 5.14453 7.06741 5.14453 6.97058C5.14453 6.87375 5.183 6.78088 5.25147 6.71241C5.31994 6.64394 5.41281 6.60547 5.50964 6.60547H8.55225ZM7.46762 14.3838C7.49546 14.7185 7.64804 15.0304 7.89512 15.2578C8.14219 15.4852 8.4657 15.6115 8.8015 15.6116H12.1975C12.5333 15.6115 12.8568 15.4852 13.1039 15.2578C13.351 15.0304 13.5036 14.7185 13.5314 14.3838L14.1195 7.33569H6.88003L7.46762 14.3838ZM9.40417 9.03955C9.50101 9.03955 9.59388 9.07802 9.66235 9.14649C9.73082 9.21496 9.76929 9.30783 9.76929 9.40466V13.5426C9.76929 13.6394 9.73082 13.7323 9.66235 13.8008C9.59388 13.8692 9.50101 13.9077 9.40417 13.9077C9.30734 13.9077 9.21447 13.8692 9.146 13.8008C9.07753 13.7323 9.03906 13.6394 9.03906 13.5426V9.40466C9.03906 9.30783 9.07753 9.21496 9.146 9.14649C9.21447 9.07802 9.30734 9.03955 9.40417 9.03955ZM11.96 9.40466C11.96 9.30783 11.9215 9.21496 11.853 9.14649C11.7846 9.07802 11.6917 9.03955 11.5948 9.03955C11.498 9.03955 11.4051 9.07802 11.3367 9.14649C11.2682 9.21496 11.2297 9.30783 11.2297 9.40466V13.5426C11.2297 13.6394 11.2682 13.7323 11.3367 13.8008C11.4051 13.8692 11.498 13.9077 11.5948 13.9077C11.6917 13.9077 11.7846 13.8692 11.853 13.8008C11.9215 13.7323 11.96 13.6394 11.96 13.5426V9.40466Z",
      fill: "#FD87B4"
    })
  ])
], -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_55 = { class: "font-semibold text-sm color-[#475467]" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "font-semibold text-sm" }
const _hoisted_58 = {
  key: 3,
  class: "w-full 2xl:w-[50%] mx-auto"
}
const _hoisted_59 = { class: "flex gap-6 items-center mt-6 mb-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "48",
    height: "48",
    rx: "24",
    fill: "#EFF4FF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M31 24H17M17 24L24 31M17 24L24 17",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_61 = { class: "font-semibold text-base text-center text-[#101828]" }
const _hoisted_62 = { class: "flex flex-col items-center justify-center mt-6" }
const _hoisted_63 = { class: "flex justify-between items-center p-4" }
const _hoisted_64 = { class: "font-semibold text-sm" }
const _hoisted_65 = { class: "inline-flex relative items-center cursor-pointer" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-transparent dark:peer-focus:ring-[#155EEF] peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#155EEF]" }, null, -1)
const _hoisted_68 = {
  key: 0,
  class: "p-4 pt-1"
}
const _hoisted_69 = { class: "font-normal text-sm pb-3 text-[#475467]" }
const _hoisted_70 = { class: "flex items-center w-full gap-4" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "flex items-center" }
const _hoisted_73 = ["disabled", "onUpdate:modelValue"]
const _hoisted_74 = { class: "ml-2 text-sm font-medium" }
const _hoisted_75 = { class: "flex items-center" }
const _hoisted_76 = ["onUpdate:modelValue", "disabled"]
const _hoisted_77 = { class: "ml-2 text-sm font-medium" }
const _hoisted_78 = ["onUpdate:modelValue"]
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<option value=\"en-ZA\">English ZA</option><option value=\"en-GB\">English GB</option><option value=\"en-AU\">English AU</option><option value=\"sv-SE\">Swedish (Sweden) (sv-SE)</option><option value=\"es-PE\">Spanish (Peru) (es-PE)</option><option value=\"af-ZA\">Afrikaans</option>", 6)
const _hoisted_85 = [
  _hoisted_79
]
const _hoisted_86 = { class: "flex" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "flex justify-between items-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_91 = { class: "font-semibold text-sm" }
const _hoisted_92 = { class: "flex justify-end items-end w-[100%] mt-6" }
const _hoisted_93 = { class: "font-semibold text-sm" }
const _hoisted_94 = { class: "font-semibold text-sm" }
const _hoisted_95 = {
  key: 4,
  class: "text-base pt-16 px-2 flex flex-col w-full 2xl:w-[50%] mx-auto"
}
const _hoisted_96 = { class: "flex gap-6 items-center pb-4" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "48",
    height: "48",
    rx: "24",
    fill: "#EFF4FF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M31 24H17M17 24L24 31M17 24L24 17",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_98 = { class: "text-[#101828] font-medium text-lg" }
const _hoisted_99 = { class: "flex items-center flex-col" }
const _hoisted_100 = { class: "my-1 font-semibold text-base" }
const _hoisted_101 = { class: "flex-row mb-4 pt-2 bg-white rounded-[1.25rem] flex items-start justify-between" }
const _hoisted_102 = { class: "flex w-full justify-evenly" }
const _hoisted_103 = {
  key: 0,
  class: "flex flex-col p-6 justify-start border border-[#84ADFF] rounded-xl"
}
const _hoisted_104 = { class: "font-semibold text-sm text-[#344054]" }
const _hoisted_105 = ["innerHTML"]
const _hoisted_106 = { class: "shadow-classes border border-[#84ADFF] rounded-lg p-2 px-4 mr-2 text-[#344054] text-sm font-semibold" }
const _hoisted_107 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_108 = {
  value: "",
  disabled: ""
}
const _hoisted_109 = ["value"]
const _hoisted_110 = {
  key: 1,
  class: "flex flex-col p-6 justify-start border border-[#84ADFF] rounded-xl"
}
const _hoisted_111 = { class: "font-semibold text-sm" }
const _hoisted_112 = ["innerHTML"]
const _hoisted_113 = { class: "shadow-classes border border-[#D0D5DD] rounded-lg p-2 px-4 mr-2 text-[#344054] text-sm font-semibold" }
const _hoisted_114 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_115 = {
  value: "",
  disabled: ""
}
const _hoisted_116 = ["value"]
const _hoisted_117 = {
  key: 0,
  class: "flex justify-end mt-8"
}
const _hoisted_118 = { class: "font-semibold text-sm" }
const _hoisted_119 = {
  key: 5,
  class: "flex flex-col items-center justify-center mt-14 w-full 2xl:w-[50%] mx-auto"
}
const _hoisted_120 = { class: "flex flex-col justify-center items-center gap-x-9 w-full" }
const _hoisted_121 = { class: "flex flex-col gap-5 overflow-auto pr-8 w-[100%]" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "48",
    height: "48",
    rx: "24",
    fill: "#EFF4FF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M31 24H17M17 24L24 31M17 24L24 17",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_123 = { class: "text-[#101828] font-medium text-lg" }
const _hoisted_124 = { class: "flex flex-col gap-y-8" }
const _hoisted_125 = { class: "flex justify-between" }
const _hoisted_126 = { class: "flex gap-3" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("svg", {
  width: "42",
  height: "42",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#F2F4F7"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.25 16C0.25 7.30152 7.30152 0.25 16 0.25C24.6985 0.25 31.75 7.30152 31.75 16C31.75 24.6985 24.6985 31.75 16 31.75C7.30152 31.75 0.25 24.6985 0.25 16Z",
    stroke: "black",
    "stroke-opacity": "0.08",
    "stroke-width": "0.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.6667 23.5C22.6667 22.337 22.6667 21.7555 22.5232 21.2824C22.2 20.217 21.3663 19.3834 20.301 19.0602C19.8278 18.9167 19.2463 18.9167 18.0834 18.9167H13.9167C12.7537 18.9167 12.1723 18.9167 11.6991 19.0602C10.6338 19.3834 9.80007 20.217 9.47691 21.2824C9.33337 21.7555 9.33337 22.337 9.33337 23.5M19.75 12.25C19.75 14.3211 18.0711 16 16 16C13.929 16 12.25 14.3211 12.25 12.25C12.25 10.1789 13.929 8.5 16 8.5C18.0711 8.5 19.75 10.1789 19.75 12.25Z",
    stroke: "#667085",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_128 = { class: "font-semibold text-[#344054] text-base" }
const _hoisted_129 = { class: "font-normal text-dark-grey text-sm" }
const _hoisted_130 = { class: "flex flex-col gap-0 px-[10px] rounded-lg w-[25rem]" }
const _hoisted_131 = { class: "text-[#344054] text-sm font-semibold pb-3" }
const _hoisted_132 = { class: "flex gap-2" }
const _hoisted_133 = { class: "flex flex-col flex-wrap gap-3 font-medium mt-1 text-sm text-white" }
const _hoisted_134 = {
  key: 0,
  class: "rounded-lg bg-[#155EEF] border border-[#155EEF] px-3 py-2 text-sm font-semibold shadow-box cursor-default"
}
const _hoisted_135 = {
  key: 1,
  class: "rounded-lg bg-[#155EEF] border border-[#155EEF] px-4 py-2 text-sm font-semibold shadow-box cursor-default"
}
const _hoisted_136 = { class: "flex gap-2" }
const _hoisted_137 = { class: "flex gap-2" }
const _hoisted_138 = {
  key: 0,
  class: "flex justify-between items-center w-full pr-8 mt-6"
}
const _hoisted_139 = { class: "text-[#475467] font-semibold text-sm" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_141 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_142 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_143 = { class: "flex flex-col bg-white gap-3 py-4 px-2" }
const _hoisted_144 = { class: "absolute right-8 top-6" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18 6L6 18M6 6L18 18",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = { class: "flex flex-col items-center gap-6 px-9" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "hidden absolute right-8 top-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "cursor-pointer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18 6L6 18M6 6L18 18",
      stroke: "#98A2B3",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19 15V18.4C19 18.9601 19 19.2401 19.109 19.454C19.2049 19.6422 19.3578 19.7951 19.546 19.891C19.7599 20 20.0399 20 20.6 20H27.4C27.9601 20 28.2401 20 28.454 19.891C28.6422 19.7951 28.7951 19.6422 28.891 19.454C29 19.2401 29 18.9601 29 18.4V16M29 33V26.6C29 26.0399 29 25.7599 28.891 25.546C28.7951 25.3578 28.6422 25.2049 28.454 25.109C28.2401 25 27.9601 25 27.4 25H20.6C20.0399 25 19.7599 25 19.546 25.109C19.3578 25.2049 19.2049 25.3578 19.109 25.546C19 25.7599 19 26.0399 19 26.6V33M33 21.3255V28.2C33 29.8802 33 30.7202 32.673 31.362C32.3854 31.9265 31.9265 32.3854 31.362 32.673C30.7202 33 29.8802 33 28.2 33H19.8C18.1198 33 17.2798 33 16.638 32.673C16.0735 32.3854 15.6146 31.9265 15.327 31.362C15 30.7202 15 29.8802 15 28.2V19.8C15 18.1198 15 17.2798 15.327 16.638C15.6146 16.0735 16.0735 15.6146 16.638 15.327C17.2798 15 18.1198 15 19.8 15H26.6745C27.1637 15 27.4083 15 27.6385 15.0553C27.8425 15.1043 28.0376 15.1851 28.2166 15.2947C28.4184 15.4184 28.5914 15.5914 28.9373 15.9373L32.0627 19.0627C32.4086 19.4086 32.5816 19.5816 32.7053 19.7834C32.8149 19.9624 32.8957 20.1575 32.9447 20.3615C33 20.5917 33 20.8363 33 21.3255Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_150 = { class: "flex flex-col items-center text-center gap-2" }
const _hoisted_151 = { class: "font-semibold text-[#101828] text-lg" }
const _hoisted_152 = { class: "font-normal text-sm text-[#475467] w-[19rem]" }
const _hoisted_153 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_154 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_155 = { key: 1 }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#FEE4E2"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#D92D20",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_157 = { class: "mt-5 text-center" }
const _hoisted_158 = { class: "text-lg font-semibold text-[##101828] mb-1" }
const _hoisted_159 = { class: "text-center" }
const _hoisted_160 = { class: "text-sm text-[#475467] mb-8" }

import {
  computed,
  ref,
  watch,
  onBeforeMount,
} from "vue";
import { useFilterStore } from "@/stores/filterStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import {
  InitialSchoolStructure,
  NewClassGroup,
  NewClassTeacher,
} from "@/interfaces/school-structure.interface";

import { TrashIcon, PencilIcon } from "@heroicons/vue/24/outline";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddGradesClassesComponent',
  setup(__props) {

const step = ref(0);
const showSendDetails = ref(false);
const teachers = ref<NewClassTeacher[]>([]);
const classGroups = ref<NewClassGroup[]>([]);
const gradeLevels = ref<number[]>([]);
const teacherEmailsApiStatus = ref<any>({});
const showModal = ref(false);
const errorMessage = ref("");

// Stores
const filterStore = useFilterStore();
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();

const steps = [
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_1'), name: i18n.global.t('add_grades_class_component.stepper.circle_1.add_teacher'), status: 'complete' },
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_2'), name: i18n.global.t('add_grades_class_component.stepper.circle_2.add_grade'), status: 'current' },
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_3'), name: i18n.global.t('add_grades_class_component.stepper.circle_3.add_asssign'), status: 'upcoming' },
  { id: i18n.global.t('add_grades_class_component.stepper.steps.step_4'), name: i18n.global.t('add_grades_class_component.stepper.circle_4.review'), status: 'upcoming' },
]

// Generate unique UUID
const generateUniqueUUID = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

// Teacher Object
const teacherObj = {
  tempId: generateUniqueUUID(),
  firstName: "",
  lastName: "",
  email: "",
  designation: "Class Teacher",
  phoneNumber: "",
  classes: [],
  status: "inactive",
  school: filterStore.selectedFilters.school,
};

// Grades Object
const selectedGrades = ref([
  {
    grade: "1",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 1,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: {},
  },
  {
    grade: "2",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 2,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "3",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 3,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "4",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 4,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "5",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 5,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "6",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 6,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: [], english: [] },
  },
  {
    grade: "7",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 7,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "8",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "",
        subject: "",
        gradeLevel: 8,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "9",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "",
        subject: "",
        gradeLevel: 9,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "10",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 10,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "11",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 11,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
  {
    grade: "12",
    selected: false,
    classes: [
      {
        tempId: generateUniqueUUID(),
        name: "",
        teacher: "", // new teacher temp id
        subject: "",
        gradeLevel: 12,
        preferredLanguage: "",
        english: false,
        maths: false,
        englishTeachers: {},
        mathsTeachers: {},
      },
    ],
    editing: { maths: false, english: false },
  },
]);

// Before mount hook
onBeforeMount(() => {
  teachers.value =
    schoolStore?.initialSchoolStructure?.teachers &&
      schoolStore?.initialSchoolStructure?.teachers.length > 0
      ? schoolStore.initialSchoolStructure.teachers
      : [];
  step.value = schoolStore?.step || 0;
  selectedGrades.value =
    schoolStore?.SelectedGrades.length > 0
      ? schoolStore.SelectedGrades
      : selectedGrades.value;
  classGroups.value = schoolStore?.initialSchoolStructure?.classGroups || [];
});

// Add teacher function
const addTeacher = () => {
  teachers.value.push({
    tempId: generateUniqueUUID(),
    firstName: "",
    lastName: "",
    email: "",
    designation: "Class Teacher",
    phoneNumber: "",
    classes: [],
    status: "inactive",
    school: filterStore.selectedFilters.school,
  });
};

// Function to check if the email already exists in the teachers array
const checkEmailExists = (email: string, index: number) => {
  return teachers.value.some(
    (teacher, i) => i !== index && teacher.email === email
  );
};

// Computed property to validate email for a specific teacher
const emailValidation = (teacherEmail: string, index: number) => {
  return computed(() => {
    // Only check if there's more than one teacher and the email is not empty
    if (teachers.value.length > 1 && teacherEmail.trim() !== "") {
      return checkEmailExists(teacherEmail, index);
    }
    // No validation error by default
    return false;
  });
};

// Function to check email registration with API (async)
const emailAlreadyRegistered = async (email: any, index: any) => {
  const result = await schoolStore?.validateEmail(email);
  teacherEmailsApiStatus.value[index] = result; // Save the result per teacher's index
};

// Trigger the API email validation check when email changes
const validateTeacherEmail = (email: any, index: any) => {
  emailAlreadyRegistered(email, index); // Call API validation
};

const isButtonDisabled = computed(() => {
  if (teachers.value.length === 0) return false;

  return teachers.value.some((teacher, index) => {
    // Check if all the fields are filled
    if (
      teacher.firstName === "" ||
      teacher.lastName === "" ||
      teacher.email === "" ||
      teacher.phoneNumber === ""
    ) {
      return true;
    }

    return (
      emailValidation(teacher.email, index).value ||
      teacherEmailsApiStatus.value[index] === true
    );
  });
});

// Watch each teacher's email and validate it using the API
watch(
  teachers,
  (newTeachers) => {
    newTeachers.forEach((teacher, index) => {
      if (teacher.email.trim() !== "") {
        // Validate with API on email change
        validateTeacherEmail(teacher.email, index);
      }
    });
    // Deep watch to track changes inside the teachers array
  },
  { deep: true }
);

const deleteTeacher = (index: number) => {
  teachers.value.splice(index, 1);
};

// Function to add a new class to the specific grade
const addClass = (gradeIndex: any) => {
  selectedGrades.value[gradeIndex].classes.push({
    tempId: generateUniqueUUID(),
    name: "",
    teacher: "", // new teacher temp id
    subject: "",
    gradeLevel: parseInt(selectedGrades.value[gradeIndex].grade),
    preferredLanguage: "",
    english: false,
    maths: false,
    englishTeachers: {},
    mathsTeachers: {},
  });
};

// Function to remove a class from a specific grade
const removeClass = (gradeIndex: number, classIndex: number) => {
  selectedGrades.value[gradeIndex].classes.splice(classIndex, 1);
};

const teacherClasses = (teacher: any, subject: string) => {
  // Find the subject ID in the store based on the subject name
  const subjectId = subjectStore.subjects.find(
    (s) => s.name.toLowerCase() === subject.toLowerCase()
  )?.id;

  return teacher.classes
    .map((classId: any) => {
      const foundClass = classGroups.value.find(
        (c: any) => c.tempId === classId
      );
      if (foundClass && foundClass.subject === subjectId) {
        return { className: foundClass.name };
      }
      return null;
    })
    .filter((classObj: any) => classObj !== null);
};

const teacherSubjects = (teacher: any) => {
  let subjects = {
    maths: false,
    english: false,
  };

  // Find the subject IDs in the store for Maths and English
  const mathsId = subjectStore.subjects.find((s) => s.name === "Maths")?.id;
  const englishId = subjectStore.subjects.find((s) => s.name === "English")?.id;

  // Loop through each class assigned to the teacher
  teacher.classes.forEach((classId: any) => {
    const foundClass = classGroups.value.find((c: any) => c.tempId === classId);

    if (foundClass) {
      if (foundClass.subject === mathsId) {
        subjects.maths = true;
      }
      if (foundClass.subject === englishId) {
        subjects.english = true;
      }
    }
  });

  return subjects;
};

const showSendDetailsModal = () => {
  //final Step
  if (teachers.value.length > 0) {
    step.value = 5;
  }
  showSendDetails.value = true;
};

const sendLogin = async () => {
  //Create the initial school structure object
  const initialSchoolStructure = {
    id: filterStore.selectedFilters.school,
    teachers: teachers.value,
    classGroups: classGroups.value,
  } as InitialSchoolStructure;

  // Update the school structure in the store
  schoolStore.updateEnableSentModal(true);

  await schoolStore.initialiseSchoolStructure(initialSchoolStructure);
};

const handleNext = () => {

  // validate class name, subject and class language
  if (step.value == 2) {

    // VALIDATION 1: Check if class name is empty for selected grades
    const invalidClassName = selectedGrades.value.some(grade =>
      grade.selected && grade.classes.some(cls => cls.name.trim() === "")
    );

    if (invalidClassName) {
      console.log("One or more classes are missing a class name.");
      errorMessage.value = i18n.global.t('add_grades_class_component.step_2.validation.className');
      showModal.value = true;
      return;
    }

    // VALIDATION 2: Check if both English and Maths are false for selected grades
    const missingSubject = selectedGrades.value.some(grade =>
      grade.selected && grade.classes.some(cls => !cls.english && !cls.maths)
    );

    if (missingSubject) {
      console.log("One or more classes are missing a selected subject.");
      errorMessage.value = i18n.global.t('add_grades_class_component.step_2.validation.subject');
      showModal.value = true;
      return;
    }

    // VALIDATION 3: Check if preferredLanguage is empty for selected grades
    const invalidLanguage = selectedGrades.value.some(grade =>
      grade.selected && grade.classes.some(cls => cls.preferredLanguage.trim() === "")
    );

    if (invalidLanguage) {
      console.log("One or more classes are missing a preferred language.");
      errorMessage.value = i18n.global.t('add_grades_class_component.step_2.validation.language');
      showModal.value = true;
      return;
    }

    // VALIDATION 4: Check if selected grades have zero classes
    const emptyClasses = selectedGrades.value.some(grade =>
      grade.selected && grade.classes.length === 0
    );

    if (emptyClasses) {
      console.log("One or more selected grades have no assigned classes.");
      errorMessage.value = i18n.global.t('add_grades_class_component.step_2.validation.grade');
      showModal.value = true;
      return;
    }
  }

  if (step.value == 2 && teachers.value.length === 0) {
    schoolStore.updateGrades(selectedGrades.value);

    schoolStore.updateClassGroups([]);
    schoolStore.updateTeachers([]);

    // Generate the class group structure
    generateClassGroupStructure();

    // Update the teachers and classGroups arrays in the store
    schoolStore.updateTeachers(teachers.value);
    schoolStore.updateClassGroups(classGroups.value);

    showSendDetailsModal();
  } else {

    step.value++;

    if (step.value == 2) {
      schoolStore.updateTeachers(teachers.value);
    }

    if (step.value == 3) {
      schoolStore.updateGrades(selectedGrades.value);
    }

    //calling classGroupStructure
    if (step.value > 3) {
      // Clear the teachers and classGroups arrays in the store
      schoolStore.updateClassGroups([]);
      schoolStore.updateTeachers([]);

      // Generate the class group structure
      generateClassGroupStructure();

      // Update the teachers and classGroups arrays in the store
      schoolStore.updateTeachers(teachers.value);
      schoolStore.updateClassGroups(classGroups.value);
    }

    //update current step to state.
    schoolStore.updateCurrentStep(step.value);
  }
};

const handleBack = () => {
  step.value--;
  schoolStore.updateCurrentStep(step.value);
};

// Function to generate the class group structure
const generateClassGroupStructure = () => {
  // Clear gradeLevels
  gradeLevels.value = [];

  //clear all their classes so that we don't push addional classes.
  for (let i = 0; i < teachers.value.length; i++) {
    teachers.value[i].classes = [];
  }

  classGroups.value = selectedGrades.value
    .filter((grade) => grade.selected)
    .map((grade) => {
      return grade.classes
        .map((c) => {
          // Find the subjects from the store based on the name
          const subjectEnglish = c.english
            ? subjectStore.subjects.find(
              (subject) => subject.name === "English"
            )?.id
            : "";
          const subjectMaths = c.maths
            ? subjectStore.subjects.find((subject) => subject.name === "Maths")
              ?.id
            : "";

          let result = [];

          // Update gradeLevels only if it is not already in the array
          const gradeLevel = parseInt(grade.grade);
          if (!gradeLevels.value.includes(gradeLevel)) {
            gradeLevels.value.push(gradeLevel);
          }

          if (subjectEnglish && !subjectMaths) {
            result.push({
              tempId: generateUniqueUUID(),
              name: c.name,
              teacher: c.englishTeachers?.tempId,
              subject: subjectEnglish, // Use the subject id
              gradeLevel: gradeLevel,
              preferredLanguage: c.preferredLanguage,
            });
          } else if (subjectMaths && !subjectEnglish) {
            result.push({
              tempId: generateUniqueUUID(),
              name: c.name,
              teacher: c.mathsTeachers?.tempId,
              subject: subjectMaths, // Use the subject id
              gradeLevel: gradeLevel,
              preferredLanguage: c.preferredLanguage,
            });
          }

          // Loop through the result array and update each teacher's classes
          for (let i = 0; i < result.length; i++) {
            // Find the teacher in the teachers array using the tempId
            let teacher = teachers.value.find(
              (t) => t.tempId === result[i].teacher
            );

            if (teacher) {
              // Check if the class is already in the teacher's classes array (to avoid duplicates)
              const classExists = teacher.classes.some(
                (clsId) => clsId === result[i].tempId
              );

              if (!classExists) {
                // If the class does not exist, push the class tempId into the teacher's classes array
                teacher.classes.push(result[i].tempId);
              }
            }
          }

          // Return the array of objects
          return result;
        })
        .flat();
    })
    .flat();
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (step.value == 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.title")), 1),
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.subtitle")), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.school_structure")), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.tell_us")), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value++)),
                  class: "bg-white border border-[#D0D5DD] font-semibold text-sm shadow-[0px 1px 2px 0px rgba(16, 24, 40, 0.05)] py-[9px] px-[13px] rounded-lg"
                }, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.btn_start")), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value > 0)
      ? (_openBlock(), _createElementBlock("ol", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (stepItem, index) => {
            return _createElementVNode("li", {
              key: stepItem.name,
              class: "md:flex-1"
            }, [
              (index < step.value - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(stepItem.id), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(stepItem.name), 1)
                  ]))
                : (index === step.value - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(stepItem.id), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(stepItem.name), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(stepItem.id), 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(stepItem.name), 1)
                    ]))
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (step.value == 1)
      ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.title")), 1),
            _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.subtitle")), 1),
            (teachers.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: _normalizeClass('px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg '
          ),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (addTeacher()))
                  }, [
                    _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add_a_teacher")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher, index) => {
            return (_openBlock(), _createElementBlock("form", {
              class: "pt-6",
              key: index
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.name")), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("select", _hoisted_31, [
                          _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.mr")), 1),
                          _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.ms")), 1),
                          _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.mrs")), 1),
                          _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.dr")), 1)
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "first_name",
                          class: "bg-white mr-[3px] border-none focus:outline-none focus:ring-0 focus:border-transparent text-[#667085] text-base block w-full p-2.5",
                          placeholder: _ctx.$t('add_grades_class_component.step_1.name'),
                          "onUpdate:modelValue": ($event: any) => ((teacher.firstName) = $event),
                          required: ""
                        }, null, 8, _hoisted_32), [
                          [_vModelText, teacher.firstName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.surname")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "last_name",
                        class: "bg-white text-[#667085] text-base rounded-lg border border-[#D0D5DD] block w-full p-2.5",
                        placeholder: _ctx.$t('add_grades_class_component.step_1.surname'),
                        "onUpdate:modelValue": ($event: any) => ((teacher.lastName) = $event),
                        required: ""
                      }, null, 8, _hoisted_35), [
                        [_vModelText, teacher.lastName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.position")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "title",
                        readonly: "",
                        class: "bg-slate-300 cursor-not-allowed text-[#667085] text-base rounded-lg border border-[#D0D5DD] block w-full p-2.5",
                        placeholder: _ctx.$t('add_grades_class_component.step_1.position'),
                        "onUpdate:modelValue": ($event: any) => ((teacher.designation) = $event),
                        required: ""
                      }, null, 8, _hoisted_38), [
                        [_vModelText, teacher.designation]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.email")), 1),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          id: "email",
                          class: "bg-white mr-[3px] border-none focus:outline-none focus:ring-0 focus:border-transparent text-[#667085] text-base block w-full p-2.5",
                          placeholder: "leah@reflective.co.za",
                          "onUpdate:modelValue": ($event: any) => ((teacher.email) = $event),
                          required: ""
                        }, null, 8, _hoisted_44), [
                          [_vModelText, teacher.email]
                        ])
                      ]),
                      (
                (emailValidation(teacher.email, index).value && index) ||
                teacherEmailsApiStatus.value[index] === true
              )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.email_exists")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.phone_number")), 1),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("select", _hoisted_49, [
                          _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.sa")), 1)
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "tel",
                          id: "phone",
                          class: "bg-white mr-[3px] border-none focus:outline-none focus:ring-0 focus:border-transparent text-[#667085] text-base block w-full p-2.5",
                          placeholder: "+27 (0) 000-0000",
                          "onUpdate:modelValue": ($event: any) => ((teacher.phoneNumber) = $event),
                          required: ""
                        }, null, 8, _hoisted_50), [
                          [_vModelText, teacher.phoneNumber]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "hidden lg:flex ml-auto mt-5",
                  onClick: ($event: any) => (deleteTeacher(index))
                }, _hoisted_53, 8, _hoisted_51)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass('flex items-center mt-6 ' + (teachers.value.length > 0 ? 'justify-between' : 'justify-end'))
          }, [
            (teachers.value.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "flex gap-[6px] items-center px-4 p-2 rounded-[1.25rem] justify-center text-[#475467]",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (addTeacher()))
                }, [
                  _hoisted_54,
                  _createElementVNode("h1", _hoisted_55, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              disabled: isButtonDisabled.value,
              class: _normalizeClass('px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg ' +
        (isButtonDisabled.value ? 'cursor-not-allowed' : 'cursor-pointer')
        ),
              onClick: handleNext
            }, [
              _createElementVNode("h1", _hoisted_57, _toDisplayString(_ctx.$t("add_grades_class_component.btn_next")) + " " + _toDisplayString(step.value + 1), 1)
            ], 10, _hoisted_56)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (step.value == 2)
      ? (_openBlock(), _createElementBlock("section", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("button", {
              class: "flex gap-6 items-center",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleBack()))
            }, [
              _hoisted_60,
              _createElementVNode("h1", _hoisted_61, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGrades.value, (grade, gradeIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: gradeIndex,
                class: "border border-[#EAECF0] rounded-lg mt-4 flex flex-col w-[100%]"
              }, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.grade")) + " " + _toDisplayString(grade.grade), 1),
                  _createElementVNode("label", _hoisted_65, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((grade.selected) = $event),
                      class: "sr-only peer"
                    }, null, 8, _hoisted_66), [
                      [_vModelCheckbox, grade.selected]
                    ]),
                    _hoisted_67
                  ])
                ]),
                (grade.selected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.subject")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.classes, (classItem, classIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: classIndex,
                          class: "flex justify-around items-center mb-3"
                        }, [
                          _createElementVNode("div", _hoisted_70, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((classItem.name) = $event),
                              class: "bg-white text-[#667085] text-base rounded-lg border w-[124px] border-[#D0D5DD] block p-2.5 py-2",
                              placeholder: "Class Name",
                              required: ""
                            }, null, 8, _hoisted_71), [
                              [_vModelText, classItem.name]
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                disabled: classItem.maths,
                                "onUpdate:modelValue": ($event: any) => ((classItem.english) = $event),
                                class: _normalizeClass('w-4 h-4 bg-white border border-[#D0D5DD] rounded-[4px] outline-none text-[#155EEF] focus:ring-[#155EEF] focus:ring-0 ' +
                  (classItem.maths ? 'cursor-not-allowed' : 'cursor-pointer')
                  )
                              }, null, 10, _hoisted_73), [
                                [_vModelCheckbox, classItem.english]
                              ]),
                              _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.english")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((classItem.maths) = $event),
                                disabled: classItem.english,
                                class: _normalizeClass('w-4 h-4 bg-white border border-[#D0D5DD] rounded-[4px] outline-none text-[#155EEF] focus:ring-[#155EEF] focus:ring-0 ' +
                  (classItem.english
                    ? 'cursor-not-allowed'
                    : 'cursor-pointer')
                  )
                              }, null, 10, _hoisted_76), [
                                [_vModelCheckbox, classItem.maths]
                              ]),
                              _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("add_grades_class_component.step_2.maths")), 1)
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((classItem.preferredLanguage) = $event),
                              class: "w-28 border border-gray-300 px-[14px] shadow-box py-2 bg-white rounded-lg text-sm"
                            }, _hoisted_85, 8, _hoisted_78), [
                              [_vModelSelect, classItem.preferredLanguage]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (removeClass(gradeIndex, classIndex)),
                              class: "flex items-center text-[#D92D20]"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                            ], 8, _hoisted_87)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (addClass(gradeIndex)),
                          class: "flex gap-[6px] items-center rounded-[1.25rem] mt-6 justify-center text-[#475467]"
                        }, [
                          _hoisted_90,
                          _createElementVNode("h1", _hoisted_91, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
                        ], 8, _hoisted_89)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_92, [
              (teachers.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg",
                    onClick: handleNext
                  }, [
                    _createElementVNode("h1", _hoisted_93, _toDisplayString(_ctx.$t("add_grades_class_component.btn_next")) + " " + _toDisplayString(step.value + 1), 1)
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg",
                    onClick: handleNext
                  }, [
                    _createElementVNode("h1", _hoisted_94, _toDisplayString(_ctx.$t("add_grades_class_component.btn_no_teachers_complete")), 1)
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value == 3)
      ? (_openBlock(), _createElementBlock("section", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("button", {
              class: "flex gap-6 items-center pb-4",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (handleBack()))
            }, [
              _hoisted_97,
              _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.assign_teacher")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGrades.value.filter((x) => x.selected), (grade, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "w-full",
                key: index
              }, [
                _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.grade")) + " " + _toDisplayString(grade.grade), 1),
                _createElementVNode("form", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    (grade.classes.some((c) => c.english == true))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.english")), 1),
                          _createElementVNode("p", {
                            class: "py-3 font-normal text-sm text-[#475467]",
                            innerHTML: _ctx.$t('add_grades_class_component.step_3.subject')
                          }, null, 8, _hoisted_105),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.classes.filter((c) => c.english == true), (c) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex items-center justify-center mb-3",
                              key: c.tempId
                            }, [
                              _createElementVNode("div", _hoisted_106, _toDisplayString(c.name.toUpperCase()), 1),
                              _withDirectives(_createElementVNode("select", {
                                id: "teachers",
                                class: "border border-[#D0D5DD] mr-10 w-40 text-[#6C6D6F] text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5",
                                placeholder: _ctx.$t('add_grades_class_component.step_3.select_teacher')
                    ,
                                "onUpdate:modelValue": ($event: any) => ((c.englishTeachers) = $event)
                              }, [
                                _createElementVNode("option", _hoisted_108, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.select_teacher")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: teacher,
                                    key: teacher.tempId
                                  }, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 9, _hoisted_109))
                                }), 128))
                              ], 8, _hoisted_107), [
                                [_vModelSelect, c.englishTeachers]
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (grade.classes.some((c) => c.maths == true))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                          _createElementVNode("p", _hoisted_111, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.maths")), 1),
                          _createElementVNode("p", {
                            class: "py-3 font-normal text-sm text-[#475467]",
                            innerHTML: _ctx.$t('add_grades_class_component.step_3.subject')
                          }, null, 8, _hoisted_112),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.classes.filter((c) => c.maths == true), (c) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex items-center justify-center mb-3",
                              key: c.tempId
                            }, [
                              _createElementVNode("div", _hoisted_113, _toDisplayString(c.name.toUpperCase()), 1),
                              _withDirectives(_createElementVNode("select", {
                                id: "teachers",
                                class: "border border-[#D0D5DD] mr-10 w-40 text-[#6C6D6F] text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5",
                                placeholder: _ctx.$t('add_grades_class_component.step_3.select_teacher')
                    ,
                                "onUpdate:modelValue": ($event: any) => ((c.mathsTeachers) = $event)
                              }, [
                                _createElementVNode("option", _hoisted_115, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.select_teacher")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: teacher,
                                    key: teacher.tempId
                                  }, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 9, _hoisted_116))
                                }), 128))
                              ], 8, _hoisted_114), [
                                [_vModelSelect, c.mathsTeachers]
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (index === selectedGrades.value.filter((x) => x.selected).length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _createElementVNode("button", {
                        class: "px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg",
                        onClick: handleNext
                      }, [
                        _createElementVNode("h1", _hoisted_118, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.btn_review")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value >= 4)
      ? (_openBlock(), _createElementBlock("section", _hoisted_119, [
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("button", {
                class: "flex gap-6 items-center",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (handleBack()))
              }, [
                _hoisted_122,
                _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.review_teachers")), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "py-5 px-4 bg-white rounded-[20px] shadow-sm border border-[#155EEF] mt-3",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _hoisted_127,
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_128, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 1),
                          _createElementVNode("h5", _hoisted_129, _toDisplayString(teacher.email), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("h1", _hoisted_131, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.classes")), 1),
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("div", _hoisted_133, [
                          (teacherSubjects(teacher).maths)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_134, " M "))
                            : _createCommentVNode("", true),
                          (teacherSubjects(teacher).english)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_135, " E "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass('flex flex-col  font-medium text-sm ' +
                    (teacherClasses(teacher, 'Maths').length > 0 &&
                      teacherClasses(teacher, 'English').length > 0
                      ? 'gap-3'
                      : 'gap-[0.20rem]')
                    )
                          }, [
                            _createElementVNode("div", _hoisted_136, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherClasses(
                          teacher,
                          'Maths'
                        ), (className, index) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  class: _normalizeClass('rounded-lg cursor-default px-4 py-2 text-[#344054] border border-[D0D5DD] mt-[3px] shadow-box font-semibold ' +
                        (teacherClasses(teacher, 'Maths').length > 0 &&
                          teacherClasses(teacher, 'English').length > 0
                          ? 'mt-[3px]'
                          : 'mt-0')
                        ),
                                  key: index
                                }, _toDisplayString(className.className.toUpperCase()), 3))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_137, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherClasses(
                          teacher,
                          'English'
                        ), (className, index) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  class: "rounded-lg cursor-default border border-[#D0D5DD] text-[#344054] px-4 py-2 shadow-box font-semibold",
                                  key: index
                                }, _toDisplayString(className.className.toUpperCase()), 1))
                              }), 128))
                            ])
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            (step.value >= 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                  _createElementVNode("button", {
                    class: "flex gap-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (step.value = 1))
                  }, [
                    _createVNode(_unref(PencilIcon), { class: "h-5 w-5 text-[#475467]" }),
                    _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.edit")), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "px-4 p-2 rounded-lg flex items-center justify-center text-white bg-[#155EEF]",
                    onClick: showSendDetailsModal
                  }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.btn_done")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: showSendDetails.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.open = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_140
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_141, [
              _createElementVNode("div", _hoisted_142, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), {
                      class: _normalizeClass('relative transform overflow-hidden rounded-[12px] bg-white text-left shadow-xl transition-all sm:my-8 py-3 pt-4 px-5')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (showSendDetails.value = false)),
                              class: "cursor-pointer",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_146))
                          ]),
                          _createElementVNode("div", _hoisted_147, [
                            _hoisted_148,
                            _hoisted_149,
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("h1", _hoisted_151, _toDisplayString(teachers.value.length > 0 ? _ctx.$t("add_grades_class_component.step_4.send_login") :
                        _ctx.$t("add_grades_class_component.step_4.send_login_no_teachers")), 1),
                              _createElementVNode("p", _hoisted_152, _toDisplayString(teachers.value.length > 0 ? _ctx.$t("add_grades_class_component.step_4.send_details") :
                        _ctx.$t("add_grades_class_component.step_4.send_details_no_teachers")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_153, [
                              _createElementVNode("button", {
                                class: "rounded-lg py-2 px-6 text-white w-full font-semibold bg-[#155EEF] focus:outline-none",
                                onClick: sendLogin
                              }, [
                                (_unref(schoolStore).loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_154, [
                                      _createVNode(_component_spinner_loader, { color: 'text-white' }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("add_grades_class_component.step_4.sending")), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_155, _toDisplayString(teachers.value.length > 0 ? _ctx.$t("add_grades_class_component.step_4.btn_send") :
                          _ctx.$t("add_grades_class_component.step_4.btn_send_no_teachers")), 1))
                              ]),
                              _createElementVNode("button", {
                                class: "border-none text-sm py-2 px-6 text-[#475467] w-full font-normal",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (showSendDetails.value = false))
                              }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.not_yet")), 1),
                              _createElementVNode("button", {
                                class: "rounded-lg border border-[#D0D5DD] text-base py-2 px-6 text-[#344054] w-full font-semibold",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (showSendDetails.value = false))
                              }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.btn_save")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-md px-4 py-6 rounded-lg',
      open: showModal.value,
      onLocalModalOpen: _cache[11] || (_cache[11] = ($event: any) => (showModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_156,
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("h3", _hoisted_158, _toDisplayString(_ctx.$t('bulk_learner_upload_component.invalid_data_modal.heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("p", _hoisted_160, _toDisplayString(errorMessage.value), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})